import PropTypes from 'prop-types';

import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

function Header({ children, sticky, ...others }) {
  const theme = useTheme();

  const headerSticky = {
    position: 'sticky',
    top: 0,
    background: theme.palette.background.default,
    zIndex: 1200,
    [theme.breakpoints.down('sm')]: {
      zIndex: 1000,
    },
  };

  return (
    <Box
      alignItems="center"
      boxShadow={`0px 1px 0px 0px ${theme.palette.darkGrey[5]}`}
      component="header"
      display="flex"
      paddingLeft={0}
      paddingTop={0}
      sx={sticky ? headerSticky : null}
      {...others}
    >
      {children}
    </Box>
  );
}

Header.propTypes = {
  children: PropTypes.node,
  sticky: PropTypes.bool,
};

export default Header;
